import type { CartLine, OrderItem } from "@/types/domain";

export const NO_MIX_REDUCTION = 0.2;

export function isNoMixDiscountEligible(item: OrderItem): boolean {
  const unit = item.base_unit_of_measure?.trim().toUpperCase();
  return (
    (unit === "KG" || unit === "TONNE") &&
    item.include_mixing_fee_in_price === true
  );
}

export function unitPriceForMixing(
  item: OrderItem,
  baseUnitPrice: number,
  enabled: boolean,
): number {
  return !enabled && isNoMixDiscountEligible(item)
    ? Math.max(0, baseUnitPrice - NO_MIX_REDUCTION)
    : baseUnitPrice;
}

export function noMixReductionPerUnit(line: CartLine): number {
  if (line.requiresMixing || !isNoMixDiscountEligible(line)) return 0;
  return Math.max(0, (line.baseUnitPrice ?? line.unitPrice) - line.unitPrice);
}
